export default "__VITE_ASSET__Ch0$8LZU__"